<template>
  <div class="map">
    <!--
    <p>
      Your Latitude: {{ coordinates.lat }} ; Your Longitude:
      {{ coordinates.lng }}
    </p>
    -->
    <GmapMap
      :center="coordinates"
      :zoom="15"
      style="width: 100%; min-height:380px; "
    ></GmapMap>
  </div>
</template>

<script>
export default {
  name: "OrderNowMap",
  data() {
    return {
      coordinates: {
        lat: 0,
        lng: 0,
      },
    };
  },
  created() {
    this.$getLocation({})
      .then((coordinates) => {
        this.coordinates = coordinates;
      })
      .catch(() => {
        console.log("Location Access Denied!");
        //this.$toast.error("Location Access Denied!");
      });
  },
};
</script>

<style lang="scss" scoped>
.map {
  h1 {
    font-weight: 400;
  }
}
</style>
